export default __webpack_public_path__ + "static/media/download-arrow.3f9803b7.svg";